// Tool access configuration
// Defines which tools are free (no login) vs premium (requires login)
// NOTE: Premium access temporarily disabled - all tools accessible without login

export const TOOL_ACCESS = {
  // FREE TOOLS - No login required
  free: [
    // All-tools overview (public browsing)
    '/tools',
    // All category pages
    '/tools/technical-seo',
    '/tools/on-page-optimization',
    '/tools/keyword-research',
    '/tools/content-creation',
    '/tools/seo-audit',
    '/tools/keyword-tracking',
    '/tools/misc-projects',
    '/tools/competitive-analysis',
    // Technical SEO tools
    '/tools/technical-seo/sitemap-validator',
    '/tools/technical-seo/robots-checker',
    '/tools/technical-seo/schema-validator',
    '/tools/technical-seo/schema-generator',
    '/tools/technical-seo/index-checker',
    '/tools/technical-seo/schema-recommender',
    '/tools/technical-seo/schema-audit',
    '/tools/content-creation/voice-profile',
    '/tools/keyword-research/serp-similarity',
    '/tools/keyword-research/keyword-clustering',
    '/tools/keyword-research/keyword-research-workflow',
    '/tools/keyword-research/content-gap',
    '/tools/keyword-research/paa-cluster',
    '/tools/content-creation/content-hub-planner',
    // On-Page Optimization
    '/tools/on-page-optimization/meta-analyzer',
    '/tools/on-page-optimization/title-optimizer',
    '/tools/on-page-optimization/heading-analyzer',
    '/tools/on-page-optimization/internal-linking',
    '/tools/on-page-optimization/keyword-cannibalization',
    '/tools/on-page-optimization/content-audit',
    '/tools/on-page-optimization/entity-seo',
    '/tools/on-page-optimization/page-seo-analyzer',
    '/tools/on-page-optimization/page-optimizer',
    // Keyword Research tools
    '/tools/keyword-research/keyword-density',
    '/tools/keyword-research/keyword-mapping',
    '/tools/keyword-research/keyword-strategy',
    // Content Creation tools
    '/tools/content-creation/content-generator',
    '/tools/content-creation/content-analyzer',
    '/tools/content-creation/content-brief',
    // SEO Audit tools
    '/tools/seo-audit/screaming-frog-analyzer',
    '/tools/seo-audit/page-type-assessment',
    '/tools/seo-audit/audit-index',
    '/tools/data-analysis/data-insights',
    // Keyword Tracking tools
    '/tools/keyword-tracking/rank-tracker',
    '/tools/keyword-tracking/position-change',
    // Misc Projects
    '/tools/misc-projects/image-optimizer',
    '/tools/misc-projects/branded-content',
    '/tools/misc-projects/plp-keywords',
    '/tools/misc-projects/seo-director',
    '/tools/seo-team',
    '/tools/seo-team/seo-director',
    '/tools/seo-team/keyword-research-agent',
    '/tools/seo-team/landing-page-auditor',
    '/tools/seo-team/website-data-collector',
    // Competitive Analysis tools
    '/tools/competitive-analysis/keyword-gap',
    '/tools/competitive-analysis/backlink-gap',
    // Dashboards
    '/dashboard/rank-tracker',
    '/dashboard/search-console',
    // Results history
    '/results',
    // Admin
    '/admin',
    '/seo-services',
    '/seo-services/builder',
  ],
  
  // PREMIUM TOOLS - Currently disabled (empty array)
  // To re-enable premium restrictions, move tools back here from the free array above
  premium: []
};

// Helper function to check if a path requires authentication
export const requiresAuth = (path) => {
  // First check if path is explicitly premium (more specific check first)
  if (TOOL_ACCESS.premium.some(premiumPath => path === premiumPath)) {
    return true;
  }
  
  // Check if path is explicitly free
  if (TOOL_ACCESS.free.some(freePath => path === freePath)) {
    return false;
  }
  
  // Home page and login are always accessible
  if (path === '/' || path === '/login' || path === '/auth/callback') {
    return false;
  }
  
  // Default to requiring auth for unknown paths
  return true;
};

// Helper to check if a specific tool is free
export const isToolFree = (toolPath) => {
  return TOOL_ACCESS.free.includes(toolPath);
};

// Helper to check if a specific tool is premium
export const isToolPremium = (toolPath) => {
  return TOOL_ACCESS.premium.includes(toolPath);
};
